import { ToastContainer } from "react-toastify";
import theme from "@monorepo/styles/theme";
import { Box, styled } from "@mui/material";

export const Main = styled(Box)(() => ({
  height: "100%",
  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
  overflowX: "hidden",
  width: "100vw",
  WebkitOverflowScrolling: "auto",
  userSelect: "none",
}));

export const StyledToastContainer = styled(ToastContainer)(() => ({
  fontFamily: "inherit !important",
  "& div": {
    fontFamily: "inherit !important",
    whiteSpace: "pre-line",
  },
}));
